"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      display: "flex",
      flex: 1
    }
  };
});

var Image = function Image(_ref) {
  var defaultValue = _ref.defaultValue,
      field = _ref.field,
      fieldId = _ref.fieldId,
      label = _ref.label,
      required = _ref.required,
      readOnly = _ref.readOnly,
      handleChange = _ref.handleChange,
      type = _ref.type;
  var classes = useStyles();
  console.log("ESTILOS IMAGE field: ", field);
  var defaultStyles = {};
  var style = !field.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(field.customStyles);
  console.log("ESTILOS IMAGE style: ", style);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("img", {
    src: field.src,
    width: field.width,
    height: field.height,
    alt: field.alt,
    srcset: field.srcset,
    sizes: field.sizes,
    style: style
  }));
};

var _default = Image;
exports.default = _default;